import React, { useEffect, useState } from 'react'
import LopBanDoApi from '../../api/LopBanDoApi';
import ol from "openlayers";
import "ol/ol.css";
import { SelectHuyen } from '../../shared/selecthuyen/SelectHuyen';
import ThongBao from '../../core/ThongBao';
import BanDoChatLuongDatApi from '../../api/BanDoChatLuongDatApi';
import LopMauApi from '../../api/LopMauApi';


export const BanDoNen = () => {
    const view = new ol.View({
        center: [11725287.264889468, 2355407.026607706],
        zoom: 11
    });
    const kieuBanDo = 1;
    var [map, setMap] = useState(new ol.Map());
    // var map;
    const [listLopBanDos, setLopBanDo] = useState([]);
    var [provinceDat, setDat] = useState(new ol.layer.Vector());
    var [sourceDat, setSourcDat] = useState(new ol.source.Vector());
    const [draw, setdraw] = useState(null);
    const [IdHuyen, setIdHuyen] = useState(0);
    var [listStyles, setListStyle] = useState([]);

    const style = (color, text) => {
        return new ol.style.Style({
            fill: new ol.style.Fill({
                color: color,
            }),
            stroke: new ol.style.Stroke({
                color: '#C0C0C0',
            }),
            text: new ol.style.Text({
                text: text,
                fill: new ol.style.Fill({
                    color: "#040482"
                })
            })
        });
    }

    const stylefunction = function (feature, resolution) {
        let madat = feature.get('dvdd');
        let index = listStyles.findIndex(x => x.MaMau === madat);
        let text = ''
        if (resolution < 10) {
            text = madat;
        }
        if (index !== -1) {
            return style(listStyles[index].MauSac, text);
        }
        else {
            return style("rgb(37 98 236 / 50%)", '');
        }
    }

    const highlightStyle = new ol.style.Style({
        fill: new ol.style.Fill({
            color: 'rgb(37 98 236 / 50%)',
        }),
        stroke: new ol.style.Stroke({
            color: '#5782ff',
            width: 1,
        }),
    });

    const loadLopBanDo = async (idhuyen) => {
        let params = {
            _tyle: kieuBanDo
        }
        listStyles = await LopMauApi.getLopBanDo(params);
        listStyles = listStyles.filter(x => x.Type === kieuBanDo);
        setListStyle(listStyles);
        params = {
            kieuBanDo: kieuBanDo,
            idHuyen: idhuyen
        }

        const list = await LopBanDoApi.getLopBanDo(params);
        list.forEach(item => {
            if (item.Type === 1) {
                let province = new ol.layer.Image({
                    source: new ol.source.ImageWMS({
                        url: item.Url,
                        params: { layers: item.LayerName, version: item.Version },
                        serverType: "geoserver",
                        ratio: item.Ratio,
                    })
                });
                province.setVisible(item.Checked);
                map.addLayer(province);
                item.province = province;
            }
            else if (item.Type === kieuBanDo) {
                sourceDat = new ol.source.Vector({
                    format: new ol.format.GeoJSON(),
                    url: item.Url
                })
                provinceDat = new ol.layer.Vector({
                    source: sourceDat,
                    style: stylefunction
                })

                function addInteractions() {
                    var flagHtml = document.getElementById('btnAdd').getAttribute('flagadd');
                    var drawNew = new ol.interaction.Draw({
                        source: sourceDat,
                        type: "Polygon",
                        style: new ol.style.Style({
                            fill: new ol.style.Fill({
                                color: '#224abe'
                            }),
                            stroke: new ol.style.Stroke({
                                color: '#224abe',
                            }),
                            image: new ol.style.Circle({
                                radius: 3,
                                fill: new ol.style.Fill({
                                    color: "#224abe",
                                }),
                            })
                        })
                    });
                    setdraw(drawNew);
                    if (flagHtml === "1") {
                        map.addInteraction(drawNew);
                    }
                }
                provinceDat.setVisible(item.Checked);
                map.addLayer(provinceDat);
                item.province = provinceDat;
                setDat(provinceDat);
                setSourcDat(sourceDat);
            }

        });
        setLopBanDo(list);
        setMap(map);
    }
    useEffect(() => {
        map = new ol.Map({
            target: "map",
            controls: new ol.control.defaults().extend([
                new ol.control.ScaleLine({
                    units: 'metric'
                }),
                new ol.control.FullScreen(),
                new ol.control.ZoomSlider()
            ]),
            layers: [
                // new ol.layer.Tile({
                //     source: new ol.source.OSM(),
                // }),
            ],
            view: view
        });
    }, []);

    const getIdHuyen = (event) => {
        if (event.value !== 0 && event.value !== IdHuyen) {
            listLopBanDos.forEach(item => {
                map.removeLayer(item.province);
            })
            setIdHuyen(event.value)
            map.setView(new ol.View({
                center: [event.toaDoX, event.toaDoY],
                zoom: event.zoom
            }));
            loadLopBanDo(event.value);
        }
    }

    const checkBoHandler = () => { };

    const clickRow = (id) => {
        listLopBanDos.forEach(item => {
            if (item.Id === id) {
                item.Checked = !item.Checked;
                map.getLayers().forEach(l => {
                    if (l === item.province) {
                        l.setVisible(item.Checked);
                    }
                })
            }
        });
        setLopBanDo([...listLopBanDos]);
        setDat(map);
    }

    return (
        <div className="card shadow mb-1">
            <div className="card-header py-2 row">
                <div className="col-md-4">
                    <h5 className="m-0 text-primary">Bản đồ nền</h5>
                </div>
                <div className="col-md-4">
                    <SelectHuyen onChangeHuyenProps={(e) => getIdHuyen(e)}></SelectHuyen>
                </div>
                <div className="col-md-4 bd-button text-right">
                    
                </div>
            </div>
            <div className="card-body ban-do-nen">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-9 ban-do" id="map">

                        </div>
                        <div className="col-md-3 list-lop">
                            <div className="row lop-ban-do">
                                <table className="table table-bordered" width="100%">
                                    <thead>
                                        <tr>
                                            <th className="col-checkbox"></th>
                                            <th>Lớp bản đồ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            listLopBanDos.map((item, key) => {
                                                return (
                                                    <tr onClick={() => clickRow(item.Id)} key={key}>
                                                        <td className="col-checkbox">
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" checked={item.Checked} onChange={checkBoHandler} />
                                                            </div>
                                                        </td>
                                                        <td>{item.Name}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
